import 'css-chunksrc/client/pages/occupancyPage/table/projectsDetail/styles.scss';export default {
  "state": "_state_1tu86_1",
  "retry": "_retry_1tu86_16"
};